import React from 'react';
import { getOrgTermsContent } from '../../../../../content/utils.js';
import StakeholderProfileTabs from '../../../../projects/Stakeholders/StakeholderProfileTabs.jsx';
import PageHeader from '../../../PageHeader.js';
import BreadCrumbs from '../../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../../icons/ProjectBreadcrumbIcon.jsx';
import {
  ProjectLink,
  ProjectsLink,
  ProjectStakeholdersLink,
} from '../../../../links/index.jsx';

const StakeholdersProfileHeader = ({ project, stakeholder, slug }) => {
  return (
    <PageHeader
      flex
      navigation={
        <StakeholderProfileTabs
          projectId={project.id}
          stakeholderId={stakeholder.id}
          slug={slug}
        />
      }
    >
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
        <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        <ProjectStakeholdersLink projectId={project.id}>
          Stakeholder Analysis
        </ProjectStakeholdersLink>
        <span>{stakeholder.name}</span>
      </BreadCrumbs>
    </PageHeader>
  );
};
export default StakeholdersProfileHeader;
